"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var format_1 = __importDefault(require("date-fns/format"));

var parse_1 = __importDefault(require("date-fns/parse"));

var react_1 = __importDefault(require("react"));

var index_1 = __importDefault(require("./index"));

var DatePickerConfirm_1 = __importDefault(require("../../DatePickerConfirm"));

var LocaleProvider_1 = __importDefault(require("../../LocaleProvider"));

var FilterItem_1 = require("../FilterItem");

var DateFilterItem =
/** @class */
function (_super) {
  __extends(DateFilterItem, _super);

  function DateFilterItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.validOperators = ['in', 'gt', 'lt', 'gte', 'lte'];

    _this.onChangeDate = function (dateString, date) {
      var value;

      if (date) {
        value = format_1.default(date, FilterItem_1.FILTER_DATE_FORMAT);
      }

      _this.setState({
        selectedValues: value
      });

      _this.props.onChange(_this.props.id, value, _this.props.operator ? _this.props.operator : DateFilterItem.defaultOperator);

      _this.closeDialog();
    };

    _this.renderLabel = function () {
      var label = _this.props.label || _this.props.id;
      var text = '';

      if (_this.value) {
        text = format_1.default(_this.value, LocaleProvider_1.default.locs.date_picker.format);
      }

      return react_1.default.createElement("div", {
        className: "input_container"
      }, react_1.default.createElement("label", null, label), react_1.default.createElement("div", {
        className: "fake_input",
        onClick: _this.openDialog,
        style: {
          textAlign: 'center'
        }
      }, text));
    };

    _this.renderDropdownBody = function () {
      return react_1.default.createElement(DatePickerConfirm_1.default, {
        value: _this.value,
        onChange: _this.onChangeDate
      });
    };

    return _this;
  }

  Object.defineProperty(DateFilterItem.prototype, "value", {
    get: function get() {
      var selectedValues = this.state.selectedValues;
      var value;

      if (Array.isArray(selectedValues)) {
        if (selectedValues.length) {
          value = parse_1.default(selectedValues[0], FilterItem_1.FILTER_DATE_FORMAT, new Date());
        }
      } else if (selectedValues) {
        value = parse_1.default(selectedValues, FilterItem_1.FILTER_DATE_FORMAT, new Date());
      }

      return value;
    },
    enumerable: true,
    configurable: true
  });
  return DateFilterItem;
}(index_1.default);

exports.default = DateFilterItem;